<template>
  <div>
    <b-card>
      <template #header>
        <b-row class="pt-1">
          <b-col cols="10" class="d-flex">
            <b-link :to="{ name: 'Blog' }">
              <h4 class="ms-2">
                {{ label.pages.blogs }}
              </h4>
            </b-link>
            /
            <h4 class="me-2">
              {{ $route.meta.label }}
              <small class="fw1">
                {{ label.pages.listBlog }}
              </small>
            </h4>
          </b-col>
          <b-col sm="2" class="text-start">
            <a
              @click="$router.go(-1)"
              v-b-tooltip.hover.right
              :title="label.pages.previousPage"
              class="mouse-change pe-3"
            >
              <b-icon
                icon="arrow-left-square-fill"
                variant="ps-base"
                scale="1.2"
                class="align-middle ms-1"
              />
            </a>
          </b-col>
        </b-row>
      </template>
      <b-card-body>
        <b-card-text>
          <b-tabs
            nav-class="tab-title"
            active-nav-item-class="tab-title-active"
            fill
            justified
            pills
          >
            <!-- Manage Blogs -->
            <b-tab active>
              <template #title> {{ label.pages.ManageBlogs }} </template>
              <DxDataGrid
                :show-row-lines="true"
                :show-column-lines="true"
                :show-borders="true"
                :row-alternation-enabled="true"
                :rtl-enabled="true"
                :data-source="posts"
                :columns="fields"
                :remote-operations="true"
                :column-auto-width="true"
                :allow-column-reordering="true"
                :allow-column-resizing="true"
                column-resizing-mode="widget"
                :hover-state-enabled="true"
                :noDataText="checkData"
                @toolbar-preparing="onToolbarPreparing($event)"
                key-expr="id"
                class="ps_Table"
                :height="dataGridHeight"
              >
                <DxSearchPanel
                  :visible="true"
                  :width="240"
                  :placeholder="label.pages.search"
                />
                <DxColumnChooser :enabled="true" mode="dragAndDrop" />
                <DxExport :enabled="true" />
                <template #btnGroup>
                  <div>
                    <b-row class="ms-2">
                      <b-col cols="auto" class="px-1">
                        <b-button
                          variant="ps-success"
                          class="py-1 pb-2"
                          size="sm"
                          v-b-tooltip.hover
                          :title="label.pages.addBlog"
                          @click="add"
                        >
                          <b-icon icon="plus" scale="2" color="#fff"></b-icon>
                        </b-button>
                      </b-col>
                      <b-col cols="auto" class="px-0">
                        <b-button
                          variant="ps-secondary"
                          class="py-1 pb-2"
                          size="sm"
                          v-b-tooltip.hover
                          :title="label.buttons.reload"
                          @click="reloadContent"
                        >
                          <b-icon
                            icon="arrow-repeat"
                            scale="1.5"
                            color="#fff"
                          ></b-icon>
                        </b-button>
                      </b-col>
                    </b-row>
                  </div>
                </template>
                <template #radif="{ data }">
                  <div>
                    {{ data.rowIndex + 1 }}
                  </div>
                </template>
                <template #btnRGroup>
                  <b-row class="btnRLanguage-wrapper" v-show="contentLanguageAccess == 1">
                    <b-col cols="3">
                      <label for="language" class="ps_label">
                        {{ label.pages.contentLanguage }}
                      </label>
                    </b-col>
                    <b-col cols="9">
                      <v-select
                        input-id="language"
                        :options="languages"
                        v-model="selectedLanguage"
                        :reduce="(group) => group.id"
                        :clearable="false"
                        class="ps_select"
                        @input="setLanguage"
                      >
                      </v-select>
                    </b-col>
                  </b-row>
                </template>
                <template #image="{ data }">
                  <div>
                    <img
                      :src="data.data.imageAddress"
                      class="ps_table_inside_img"
                    />
                  </div>
                </template>
                <template #actions="{ data }">
                  <b-row class="justify-content-center">
                    <b-col cols="auto" class="px-0">
                      <button
                        @click="edit(data)"
                        :id="'editBtnTlp-' + data.data.id"
                      >
                        <b-icon
                          icon="dash-square-fill"
                          scale="1.1"
                          variant="ps-edit-icon"
                        ></b-icon>
                      </button>
                      <b-tooltip
                        boundary="#app"
                        noninteractive
                        triggers="hover"
                        :target="'editBtnTlp-' + data.data.id"
                      >
                        {{ label.buttons.edit }}
                      </b-tooltip>
                    </b-col>
                    <b-col cols="auto" class="px-0 pe-2">
                      <button
                        @click="delConfirm(data)"
                        :id="'deleteBtnTlp-' + data.data.id"
                      >
                        <b-icon
                          icon="x-square-fill"
                          scale="1.1"
                          variant="ps-delete-icon"
                        ></b-icon>
                      </button>
                      <b-tooltip
                        boundary="#app"
                        noninteractive
                        triggers="hover"
                        :target="'deleteBtnTlp-' + data.data.id"
                      >
                        {{ label.buttons.delete }}
                      </b-tooltip>
                    </b-col>
                  </b-row>
                </template>
                <DxSorting mode="multiple" />
                <DxLoadPanel :enabled="true" />
                <DxScrolling mode="virtual" />
                <DxStateStoring
                  :enabled="true"
                  type="localStorage"
                  storage-key="adminBlog"
                />
              </DxDataGrid>
            </b-tab>

            <!-- Deleted Blogs -->
            <b-tab>
              <template #title> {{ label.pages.deletedBlogs }} </template>
              <DxDataGrid
                :show-row-lines="true"
                :show-column-lines="true"
                :show-borders="true"
                :row-alternation-enabled="true"
                :rtl-enabled="true"
                :data-source="deletePosts"
                :columns="fields"
                :remote-operations="true"
                :column-auto-width="true"
                :allow-column-reordering="true"
                :allow-column-resizing="true"
                column-resizing-mode="widget"
                :hover-state-enabled="true"
                :noDataText="checkData"
                @toolbar-preparing="onToolbarPreparing($event)"
                key-expr="id"
                class="ps_Table"
                :height="dataGridHeight - 50"
              >
                <DxSearchPanel
                  :visible="true"
                  :width="240"
                  :placeholder="label.pages.search"
                />
                <DxColumnChooser :enabled="true" mode="dragAndDrop" />
                <DxExport :enabled="true" />
                <template #btnGroup>
                  <div>
                    <b-row class="ms-2">
                      <b-col cols="auto" class="px-0">
                        <b-button
                          variant="ps-secondary"
                          class="py-1 pb-2"
                          size="sm"
                          v-b-tooltip.hover
                          :title="label.buttons.reload"
                          @click="reloadDeletePost"
                        >
                          <b-icon
                            icon="arrow-repeat"
                            scale="1.5"
                            color="#fff"
                          ></b-icon>
                        </b-button>
                      </b-col>
                    </b-row>
                  </div>
                </template>
                <template #btnRGroup />
                <template #radif="{ data }">
                  <div>
                    {{ data.rowIndex + 1 }}
                  </div>
                </template>
                <template #image="{ data }">
                  <div>
                    <img
                      :src="data.data.imageAddress"
                      class="ps_table_inside_img"
                    />
                  </div>
                </template>
                <template #actions="{ data }">
                  <b-row class="justify-content-center">
                    <b-col cols="auto" class="px-0">
                      <button
                        @click="restore(data)"
                        :id="'restoreBtnTlp-' + data.data.id"
                      >
                        <b-icon
                          icon="arrow-right-square-fill"
                          scale="1.1"
                          variant="ps-edit-icon"
                        ></b-icon>
                      </button>
                      <b-tooltip
                        boundary="#app"
                        noninteractive
                        triggers="hover"
                        :target="'restoreBtnTlp-' + data.data.id"
                      >
                        {{ label.buttons.restore }}
                      </b-tooltip>
                    </b-col>
                  </b-row>
                </template>
                <DxSorting mode="multiple" />
                <DxLoadPanel :enabled="true" />
                <DxScrolling mode="virtual" />
              </DxDataGrid>
            </b-tab>
          </b-tabs>
        </b-card-text>
      </b-card-body>
    </b-card>

    <!-- Delete Confirm Modal -->
    <b-modal dir="rtl" v-model="delModal" hide-header centered>
      <b-container fluid>
        <b-row class="mt-2">
          <p class="fs10 text-center lh1">
            {{ label.captions.deleteConfirm }}
            <br />
            <strong>«{{ delTitle }}»</strong>
          </p>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
              variant="ps-secondary"
              size="sm"
              class="mx-1"
              @click="delModal = false"
            >
              {{ label.buttons.cancel }}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
              v-if="!loadingBtn"
              variant="ps-danger"
              size="sm"
              class="mx-1"
              @click="deletePost"
            >
              {{ label.buttons.deleteConfirm }}
            </b-button>
            <b-button
              v-else
              disabled
              variant="ps-danger"
              size="sm"
              class="mx-1"
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>

     <!-- restore Confirm Modal -->
     <b-modal dir="rtl" v-model="restoreModal" hide-header centered>
      <b-container fluid>
        <b-row class="mt-2">
          <p class="fs10 text-center lh1">
            {{ label.captions.resetorConfirm }}
            <br />
            <strong>«{{ restoreTitle }}»</strong>
          </p>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
              variant="ps-secondary"
              size="sm"
              class="mx-1"
              @click="restoreModal = false"
            >
              {{ label.buttons.cancel }}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
              v-if="!loadingBtn"
              variant="ps-danger"
              size="sm"
              class="mx-1"
              @click="restorePost"
            >
              {{ label.buttons.recycleConfirm }}
            </b-button>
            <b-button
              v-else
              disabled
              variant="ps-danger"
              size="sm"
              class="mx-1"
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { dataGridMixin } from "@/components/dataGrid/dataGridMixin";
import label from "@/plugins/StaticLabels.js";
import { contentLanguage } from "@/plugins/ContentLangMixin.js";

export default {
  name: "BlogList",
  mixins: [dataGridMixin, contentLanguage],
  data() {
    return {
      label,
      fields: [
        {
          cellTemplate: "radif",
          caption: "ردیف",
          allowSorting: false,
          allowFiltering: false,
          width: "100",
          cssClass: "text-center align-middle",
        },
        {
          cellTemplate: "actions",
          caption: "عملیات",
          allowSorting: false,
          allowFiltering: false,
          width: "110",
          alignment: "center",
        },
        {
          dataField: "title",
          caption: "نام",
          dataType: "string",
          alignment: "center",
        },
        {
          cellTemplate: "image",
          caption: "تصویر",
          allowSorting: false,
          allowFiltering: false,
          width: "100",
          alignment: "center",
        },
        {
          dataField: "visit",
          caption: "تعداد بازدید",
          dataType: "number",
          alignment: "center",
        },
        {
          dataField: "writer",
          caption: "نویسنده",
          dataType: "string",
          alignment: "center",
        },
        {
          dataField: "createdLocal",
          caption: "تاریخ ثبت",
          dataType: "string",
          alignment: "center",
        },
        {
          dataField: "isConfirm",
          caption: "وضعیت",
          dataType: "boolean",
          alignment: "center",
        },
      ],
      delId: null,
      delModal: false,
      delTitle: null,
      restoreForm:{
        ids: [],
      },  
      restoreModal: false,
      restoreTitle: null, 
    };
  },
  computed: {
    ...mapGetters({
      postCheck: "postCheck",
      posts: "baseX/posts",
      deletePosts: "baseX/deletePosts",
      loadingBtn: "loadingBtn",
    }),
  },
  watch: {
    postCheck() {
      if (this.postCheck) {
        this.reloadContent();
        this.reloadDeletePost();
      }
    },
  },
  methods: {
    add() {
      this.$router.push({ name: "AddBlog" });
    },
    edit(item) {
      const ids = [];
      ids.push(item.data.id);
      this.$store.dispatch("baseX/isAdminReadBlog", ids);
      this.$router.push({ name: "EditBlog", params: { id: item.data.id } });
    },
    delConfirm(item) {
      this.delId = item.data.id;
      this.delTitle = item.data.title;
      this.delModal = true;
    },
    deletePost() {
      this.$store.dispatch("baseX/deletePost", this.delId);
      this.delModal = false;
    },
    restore(item) {
      this.restoreForm.ids.push(item.data.id);
      this.restoreTitle = item.data.title;
      this.restoreModal = true;
    },
    restorePost() {
      this.$store.dispatch("baseX/restorePost", this.restoreForm);
      this.restoreModal = false;
    },
    reloadDeletePost() {
      let payload = "languageId=" + this.selectedLanguage;
      payload += "&isDelete=true";
      this.$store.dispatch("baseX/getDeletePosts", payload);
    },
    reloadContent() {
      let payload = "languageId=" + this.selectedLanguage;
      payload += "&isDelete=false";
      this.$store.dispatch("baseX/getPosts", payload);
    },
  },
  mounted() {
    this.reloadContent();
    this.reloadDeletePost();
  },
};
</script>
